module.exports = __webpack_public_path__ + "img/gd-e-fes-tick.3832853d.png";